define('controllers/user',['require','controllers/base/controller','views/pages/user/details','models/pages/user/details','views/pages/user/login','models/pages/user/login','views/pages/user/password','models/pages/user/password'],function(require) {
    'use strict';

    var Controller = require('controllers/base/controller'),
        UserPageDetailView = require('views/pages/user/details'),
        UserPageDetailModel = require('models/pages/user/details'),
        UserPageLoginView = require('views/pages/user/login'),
        UserPageLoginModel = require('models/pages/user/login'),
        UserPagePasswordView = require('views/pages/user/password'),
        UserPagePasswordModel = require('models/pages/user/password');

    var UserController = Controller.extend({
        show: function(params) {
            var page = params.page, model, view;
            var data = {
                userId: params.userId
            };

            if (page === 'details') {
                model = new UserPageDetailModel(data);
                view = new UserPageDetailView({model: model});
            }
            if (page === 'login') {
                model = new UserPageLoginModel(data);
                view = new UserPageLoginView({model: model});
            }
            if (page === 'password') {
                model = new UserPagePasswordModel(data);
                view = new UserPagePasswordView({model: model});
            }

            this.view = view;

            model.load(true);

        }
    });

    return UserController;
});
